module.exports = __webpack_public_path__ + "static/media/do-pobrania-plan-lekcji.2b2ef711.png";